import {Routes} from '@angular/router';

export const content: Routes = [
  {
    path: 'home',
    loadChildren: () => import('../../layouts/components/home/home.module').then(m => m.HomeModule),
  },
  {
    path: 'general/admin',
    loadChildren: () => import('../../layouts/components/admin/admin.module').then(m => m.AdminModule)
  },
  {
    path: 'general/agent',
    loadChildren: () => import('../../layouts/components/agent/agent.module').then(m => m.AgentModule)
  },
  {
    path: 'general/auditor',
    loadChildren: () => import('../../layouts/components/auditor/auditor.module').then(m => m.AuditorModule)
  },
  {
    path: 'stage',
    loadChildren: () => import('../../layouts/components/stage/stage.module').then(m => m.StageModule)
  },
  {
    path: 'reason',
    loadChildren: () => import('../../layouts/components/reason/reason.module').then(m => m.ReasonModule)
  },
  {
    path: 'campaigns',
    loadChildren: () => import('../../layouts/components/campaigns/campaigns.module').then(m => m.CampaignsModule)
  },
  {
    path: 'lead',
    loadChildren: () => import('../../layouts/components/lead/lead.module').then(m => m.LeadModule)
  },
  {
    path: 'profile',
    loadChildren: () => import('../../layouts/components/profile/profile.module').then(m => m.ProfileModule)
  },
  {
    path: 'template',
    loadChildren: () => import('../../layouts/components/template/template.module').then(m => m.TemplateModule)
  },
  {
    path: 'audit',
    loadChildren: () => import('../../layouts/components/recordings/recordings.module').then(m => m.RecordingsModule)
  },
  {
    path: 'support-ticket',
    loadChildren: () => import('../../layouts/components/support-ticket/support-ticket.module').then(m => m.SupportTicketModule)
  },
  {
    path: 'bulk',
    loadChildren: () => import('../../layouts/components/bulk/bulk.module').then(m => m.BulkModule)
  },
  /*{
    path: 'apps',
    loadChildren: () => import('../../layouts/components/app/app.module').then(m => m.AppModule)
  },*/
];

export const landing: Routes = [
  {
    path: 'landing',
    loadChildren: () => import('../../landing/pages-list/Landing/Landing.module').then(m => m.LandingModule)
  }
];
